module.exports = __webpack_public_path__ + "img/SKWINKELNetActieInschrijvenE2A637.0f70985b.png";